export default "__VITE_ASSET__D2WVM6Gl__"